"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const eventConstants_1 = require("../../../constants/eventConstants");
const styles_1 = __importDefault(require("../../../styles/styles"));
const icon_1 = __importDefault(require("../../icon/icon"));
const pressable_1 = __importDefault(require("../../pressable/pressable"));
const Dropdown = ({ contactsList, selectedContactIndex, setSelectedContactIndex, }) => {
    const [visible, setVisible] = react_1.useState(false);
    const toggleMenu = () => setVisible(!visible);
    // TODO check why this happens on an array
    const selectedContact = contactsList[selectedContactIndex]; // nosemgrep: javascript.lang.security.audit.detect-bracket-object-injection.detect-bracket-object-injection
    const formattedContact = (firstName, lastName, relationship) => (react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexDirectionRow },
        react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorBlack, styles_1.default.fontSizeText] }, `${firstName} ${lastName}`),
        relationship ? (react_1.default.createElement(react_native_paper_1.Title, { style: [styles_1.default.textColorGray, styles_1.default.fontSizeText] }, `- ${relationship}`)) : null));
    const menuItemHandler = (index) => {
        setSelectedContactIndex(index);
        toggleMenu();
    };
    const anchorContent = formattedContact(selectedContact.first_name, selectedContact.last_name, selectedContact.relationship || null);
    const anchor = (react_1.default.createElement(pressable_1.default, { onPress: toggleMenu, style: [styles_1.default.flexDirectionRow, styles_1.default.anchorStyle], eventName: eventConstants_1.CONTACTS_DROPDOWN },
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.flexFour] }, anchorContent),
        visible ? react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faChevronUp }) : react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faChevronDown })));
    return (react_1.default.createElement(react_native_paper_1.Menu, { visible: visible, onDismiss: toggleMenu, anchor: anchor, contentStyle: styles_1.default.whiteBackground }, contactsList.map((el, index) => (react_1.default.createElement(react_native_paper_1.Menu.Item
    // no unique attribute for key
    // eslint-disable-next-line react/no-array-index-key
    , { 
        // no unique attribute for key
        // eslint-disable-next-line react/no-array-index-key
        key: index, onPress: () => menuItemHandler(index), title: formattedContact(el.first_name, el.last_name, el.relationship || null) })))));
};
exports.default = Dropdown;
